<template>
  <v-layout row justify-center style="position: relative;">
    <v-dialog v-model="dialog" persistent width="400" @input="$emit('close')">
      <v-card>
        <v-card-title class="center">
          <div class="headline">Advertencia!</div>
        </v-card-title>
        <v-card-text>¿Estas seguro que deseas eliminar {{text}}?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="red--text darken-1" flat="flat" @click="cancel()">NO</v-btn>
          <v-btn class="red--text darken-1" flat="flat" @click="deleteItem(id)">SI</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import EventBus from '@/event-bus';

export default {
  props: {
    dialog: Boolean,
    url: {
      type: String,
      default: '',
    },
    id: Number,
    text: String,
    deleteBus: {
      type: Object,
      default() {
        return {
          onDelete: 'deleteItem',
          deleted: 'deleted',
          canceled: 'cancelDelete',
        };
      },
    },
  },
  methods: {
    deleteItem(id) {
      this.axios.delete(`/${this.url}/${id}`).then(() => {
        this.$emit('deleted', id);
        EventBus.$emit('update');
        EventBus.$emit(this.deleteBus.deleted);
      }).catch(() => {
        EventBus.$emit(this.deleteBus.deleted);
      });
    },
    cancel() {
      this.$emit('close');
      EventBus.$emit(this.deleteBus.deleted);
    },
  },
};
</script>

<style scoped>
.center{
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/global/DeleteDialog.vue